import { useRef, useEffect } from "react";
import { Box, TextField, InputAdornment, Button, Grow } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';

const SearchBar = ({
  handleSearch,
  isSearchBarOpen,
  setIsSearchBarOpen,
  excludedViewRef,
}) => {
  const searchBarRef = useRef(null);

  const handleClick = () => {
    if (isSearchBarOpen) {
      handleSearch({ target: { value: "" } });
    }
    setIsSearchBarOpen(!isSearchBarOpen);
  }

  // close search bar when clicked outside of search bar, but ignore the excluded sections
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isSearchBarClicked = searchBarRef.current?.contains(event.target);
      const isExcludedViewClicked = excludedViewRef?.current?.contains(event.target);

      if (isSearchBarOpen && !isSearchBarClicked && !isExcludedViewClicked) {
        setIsSearchBarOpen(false);
        handleSearch({ target: { value: "" } });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSearchBarOpen, excludedViewRef]);

  return (
    <Box ref={searchBarRef}>
      {isSearchBarOpen &&
        <Grow in={isSearchBarOpen} timeout={300}>
          <TextField
            autoFocus
            id="input-with-icon-textfield"
            sx={{
              marginTop: "5px",
              width: "200px",
              "& .MuiInput-underline:before": {
                borderBottomColor: "primary.main",
                },
              "& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before": {
                borderBottomColor: "primary.main",
              },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ color: "primary.main" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment
                    position="end"
                  >
                    <Button
                      onClick={handleClick}
                      sx={{
                        color: "grey",
                        paddingRight: "0px",
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                      }}
                    >
                      <CloseIcon />
                    </Button>
                  </InputAdornment>
                ),
                sx: {
                  fontWeight: "bold",
                  color: "secondary.main",
                },
              },
            }}
            variant="standard"
            onChange={handleSearch}
          />
        </Grow>
      }

      <Button
        onClick={handleClick}
        sx={{
          paddingRight: "0px",
          color: isSearchBarOpen ? "primary.main" : "grey",
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
        disableRipple
      >
        <SearchIcon />
      </Button>
    </Box>
  );
};

export default SearchBar;